import {
    TranslocoModule,
    TranslocoService,
    provideTransloco
} from '@ngneat/transloco';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'environments/environment';
import { TranslocoHttpLoader } from 'app/core/transloco/transloco.http-loader';

@NgModule({
    exports  : [
        TranslocoModule
    ],
    providers: [
        ...provideTransloco({
            config: {
                availableLangs      : [
                    { id: 'en', label: 'English' },
                    { id: 'tr', label: 'Turkish' }
                ],
                defaultLang         : 'en',
                fallbackLang        : 'en',
                reRenderOnLangChange: true,
                prodMode            : environment.production
            },
            loader: TranslocoHttpLoader
        }),
        provideAppInitializer(() => {
            const translocoService = inject(TranslocoService);
            const defaultLang = translocoService.getDefaultLang();
            translocoService.setActiveLang(defaultLang);
            return firstValueFrom(translocoService.load(defaultLang));
        })
    ]
})
export class TranslocoCoreModule
{
}
